import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import {
    buildGA4ItemsFromCartLines,
    getCurrencyCode,
    trackGA4Purchase,
} from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4PurchaseEvent: typeof SendTracking = props => {
    if (!props.cartToUpdate?.cartLines?.length || !props.apiResult?.cart?.orderNumber) {
        return;
    }

    const currency = getCurrencyCode(props.getState());
    const items = buildGA4ItemsFromCartLines(props.cartToUpdate.cartLines);

    trackGA4Purchase(
        items,
        currency,
        props.apiResult.cart.orderNumber,
        props.cartToUpdate.orderGrandTotal,
        props.cartToUpdate.totalTax,
        props.cartToUpdate.shippingAndHandling,
        props.cartToUpdate.promotionCode || undefined,
    );

    try {
        sessionStorage.removeItem("ga4_begin_checkout_cartId");
    } catch {
        // sessionStorage unavailable
    }
};

addToChainAfter(chain, SendTracking, SendGA4PurchaseEvent);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
